<template>
  <div class="ly_mainInner">
    <!-- 級選択画面 -->
    <div id="selectGrade">
      <div class="bl_txtBlock">
        <p><ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby>をえらぶ</p>
      </div>
      <ul class="bl_selectGradeBtnBlock">
        <li v-for="n in 5" :key="n" class="bl_selectGradeBtn" :class="isClearGrade(6-n)">
          <input v-model="selectLevel.grade" type="radio" :id="6-n" :value="6-n">
          <label :for="6-n">
            <!-- eslint-disable-next-line -->
            <p class="pcBlock bl_selectGradeBtn_txt">{{ 6 - n }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby></p>
            <transition name="GradeClearStamp">
              <span v-if="is_clear_grade" class="el_gradeClearStamp"></span>
            </transition>
          </label>
          <!-- eslint-disable-next-line -->
          <p class="spBlock bl_selectGradeBtn_txt">{{ 6 - n }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby></p>
        </li>
      </ul>
      <div class="bl_noteBlock">
        <!-- eslint-disable-next-line -->
        <p class="bl_noteBlock_txt"><ruby>色<rp>(</rp><rt>いろ</rt><rp>)</rp></ruby>のついた<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby>にチャレンジしよう！<br><ruby>遊<rp>(</rp><rt>あそ</rt><rp>)</rp></ruby>んだきろくは<ruby>自動<rp>(</rp><rt>じどう</rt><rp>)</rp></ruby>で<ruby>保存<rp>(</rp><rt>ほぞん</rt><rp>)</rp></ruby>されるよ</p>
        <div class="bl_noteBlock_img">
          <img src="/kids/quiz/static/image/select_img_02.png" alt="">
        </div>
      </div>
      <div class="bl_btnBlock">
        <!-- eslint-disable-next-line -->
        <a class="el_btn" href="#" @click="isGrade()">この<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby>にチャレンジ</a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

export default {
  name: 'SelectGrade',
  data() {
    return {
      selectLevel: {
        grade: '',
        stage: '',
        questionCount: 1,
      },
      clearStageCount: '',
    };
  },
  computed: {
    // クリアしたデータを取得
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
  },
  created() {
    // 次にチャレンジする級・ステージをカレント表示
    if (this.clearData.grade === 1 && this.clearData.stage === 4) {
      this.$set(this.selectLevel, 'grade', 1);
    } else {
      if (this.clearData.grade === 0) {
        this.$set(this.selectLevel, 'grade', 5);
      } else if (this.clearData.stage !== 4) {
        this.$set(this.selectLevel, 'grade', this.clearData.grade);
      } else {
        this.$set(this.selectLevel, 'grade', this.clearData.grade - 1);
      }
    }
    // クリアしたステージ数の合計を保持
    this.clearStageCount = this.stageCount(this.clearData.grade, this.clearData.stage);
  },
  methods: {
    // ページ遷移
    changeCurrentPage(page) {
      this.$store.commit('currentPage/changeCurrentPage', page);
    },
    // 級が選択されているか
    isGrade() {
      if (this.selectLevel.grade > 0 && this.selectLevel.grade <= 5) {
        if (
          (this.selectLevel.grade > this.clearData.grade && this.clearData.grade !== 0) ||
          (this.clearData.grade === 1 && this.clearData.stage === 4)
        ) {
          this.selectLevel.stage = 4;
        } else if (
          this.clearData.grade <= this.selectLevel.grade ||
          (this.clearData.stage % 4 === 0 && this.clearData.grade - 1 === this.selectLevel.grade)
        ) {
          this.selectLevel.stage = this.clearData.stage % 4 + 1;
        }
        this.$store.commit('selectLevel/setSelectLevel', this.selectLevel);
        this.changeCurrentPage('selectStage');
      }
      return false;
    },
    // クリアした級か
    isClearGrade(num) {
      if (this.clearData.grade !== 0) {
        if (this.clearData.grade === num && this.clearData.stage === 4) {
          this.is_clear_grade = true;
          return {
            is_clear_grade: true,
          };
        } else if (this.clearData.grade < num) {
          this.is_clear_grade = true;
          return {
            is_clear_grade: true,
          };
        }
      }
      this.is_clear_grade = false;
      return {
        is_clear_grade: false,
      };
    },
    // クリアしたステージ数の合計を算出
    stageCount(grade, stage) {
      if (grade !== 0) {
        return (((5 - grade) * 4) + stage);
      }
      return 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

ruby{
  > rt{
    font-size: 10px;
  }
}

.GradeClearStamp-leave-active {
  display: none;
}

.el_gradeClearStamp {
  position: absolute;
  top: 0;
  left: 0;
  background: url('/kids/quiz/static/image/clear_img_01.png') center no-repeat;
  background-size: 90% auto;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 1;
  animation: StampBounce 1s ease;
}

@keyframes StampBounce {
  0% { opacity: 0; transform: scale(2.0, 2.0); }
  80% { opacity: 1; transform: scale(0.95, 0.95); }
  95% { transform: scale(1.15, 1.15); }
  100% { transform: scale(1, 1); }
}

.ly_main{
  .el_btn{
    max-width: 324.7px;
  }

  .ly_mainInner{
    .bl_txtBlock{
      font-size: 34px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 60px;
    }

    .bl_noteBlock{
      display: flex;
      flex-flow: row-reverse;
      justify-content: center;
      align-items: center;
      margin-bottom: 32.7px;

      .bl_noteBlock_txt{
        padding: 30px 25px 25px 33px;
        // width: 460px;
        font-size: 22px;
        font-weight: 500;
        color: #000;
        line-height: 2.41;
        background-color: #fff;
        opacity: 0.6;
        border-radius: 20px;
        position: relative;
        z-index: 1;
        margin-left: 24px;

        &::before{
          margin: auto;
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 100%;
          border: 8px solid transparent;
          border-right: 15px solid #fff;
        }
      }

      .bl_noteBlock_img{
        width: 160px;
      }
    }

    .bl_btnBlock{
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }

    #selectGrade{
      width: 100%;

      .bl_selectGradeBtnBlock{
        display: flex;
        justify-content: center;
        margin-bottom: 46px;

        .bl_selectGradeBtn{
          box-sizing: border-box;
          margin-right: 22px;
          position: relative;
          color: #ada49b;
          font-size: 32px;
          font-weight: bold;

          &:last-of-type{
            margin-right: 0;
          }

          &:first-of-type{
            color: #000;

            &::after{
              background-color: #000 !important;
            }

            > label{
              border: 3px solid #000;
              background-color: #fff;
              color: #000;
              cursor: pointer;
              pointer-events: painted;
              position: relative;
            }
          }

          &:not(:last-of-type){
            &::after{
              content: "";
              position: absolute;
              top: 50%;
              right: -22px;
              width: 22px;
              height: 3px;
              background-color: #ada49b;
            }
          }

          > label {
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: 152px;
            max-height: 152px;
            width: 14.844vw;
            height: 14.844vw;
            border: 3px solid #ada49b;
            border-radius: 50%;
            pointer-events: none;

            .bl_selectGradeBtn_txt{
              text-align: center;
            }
          }

          &:nth-of-type(1) {
            input[type=radio] {
              &:checked{
                + label{
                  background-color: #7ed321 !important;
                }
              }
            }
          }

          &:nth-of-type(2) {
            input[type=radio] {
              &:checked{
                + label{
                  background-color: #f57f23 !important;
                }
              }
            }
          }

          &:nth-of-type(3) {
            input[type=radio] {
              &:checked{
                + label{
                  background-color: #f8e71c !important;
                }
              }
            }
          }

          &:nth-of-type(4) {
            input[type=radio] {
              &:checked{
                + label{
                  background-color: #bb55d0 !important;
                }
              }
            }
          }

          &:nth-of-type(5) {
            input[type=radio] {
              &:checked{
                + label{
                  background-color: #ff4f65 !important;
                }
              }
            }
          }

          &.is_clear_grade{

            &::after{
              background-color: #000;
            }

            > label{
              border: 3px solid #000;
              background-color: #fff;
              color: #000;
              cursor: pointer;
              pointer-events: painted;

              .bl_selectGradeBtn_txt{
                color: #000;
              }
            }

            + .bl_selectGradeBtn{
              > label{
                border: 3px solid #000;
                background-color: #fff;
                cursor: pointer;
                pointer-events: painted;
                position: relative;
              }

              &::after{
                background-color: #000;
              }

              .bl_selectGradeBtn_txt{
                color: #000;
              }
            }
          }
        }
      }
    }
  }
}


@media screen and (max-width: 768px){
  .ly_main{
    .ly_mainInner{

      .bl_txtBlock{
        font-size: 26px;
        margin-bottom: 32px;
      }

      .bl_btnBlock{
        flex-direction: column;
      }

      #selectGrade{
        .bl_selectGradeBtnBlock{
          margin-bottom: 28px;

          .bl_selectGradeBtn{
            margin-right: 2.25vw;

            &:not(:last-of-type){
              &::after{
                width: 2.25vw;
                top: 8vw;
                right: -2.25vw;
              }
            }

            > label{
              width: 16vw;
              height: 16vw;
            }

            .bl_selectGradeBtn_txt{
              margin-top: 10px;
              font-size: 20px;
              text-align: center;
            }
          }
        }

        .bl_noteBlock{
          flex-direction: column;

          .bl_noteBlock_txt{
            margin-left: 0;
            margin-bottom: 28px;
            padding: 15px;
            font-size: 18px;

            &::before{
              margin-top: 10px;
              top: 100%;
              transform: translate(-50%,-50%);
              left: 50%;
              right: auto;
              border: 8px solid transparent;
              border-top: 15px solid #fff;
            }
          }

          .bl_noteBlock_img{
            width: 172px;
            margin-right: 33vw;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectGrade.vue